import { Message } from 'az-platform-ui';
import { Link } from "react-router-dom";

export const RouteNotFound =() => {
    return (<>
        <div className="flex flex-column">
                <Message severity="error" icon =' ' text= {<h2> 404 Error </h2>} />
                <h3 className='text-center'>PAGE NOT FOUND!!</h3>
                <p className='text-center font-italic'> The Page you were looking for could not be found.</p>
                <div className='text-center'>
                    <Link to={'/'}> Home </Link>
                </div>
        </div>
    </>)
}